module.exports = __webpack_public_path__ + "img/Homex.1104ef6a.svg";